import { render, staticRenderFns } from "./EscalationReason.vue?vue&type=template&id=28b1908c&"
import script from "./EscalationReason.vue?vue&type=script&lang=ts&"
export * from "./EscalationReason.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports